import { __assign, __rest } from "tslib";
import React from 'react';
import { Popover } from '@hose/eui';
import { FledgedProfileCard } from './fledged-profile-card';
import styles from './profile-card.module.less';
export var PopupProfileCard = function (_a) {
    var staffId = _a.staffId, children = _a.children, rest = __rest(_a, ["staffId", "children"]);
    return (React.createElement(Popover, __assign({ overlayClassName: styles['popover'], trigger: "click" }, rest, { destroyTooltipOnHide: { keepParent: true }, content: React.createElement(FledgedProfileCard, { staffId: staffId }) }), children));
};
